import {Dropdown} from "primereact/dropdown";
import {Classes, Labeled} from "./Basics";

type Properties = Classes & Labeled & {
    val: any
    options: Array<number>
    onChange: (val: number) => void
    disable?: boolean
}

function PredefinedNumberSetProperty(props: Properties) {
    function handleOnChange(e: any) {
        if (props.onChange != null) {
            props.onChange(+e.value)
            e.preventDefault()
        }
    }

    return <>
        <div className={"property-element"}>
            <label
                className={(props.labelAdditionalClassName == null ? "" : (" " + props.labelAdditionalClassName))}>
                {props.label}
            </label>
            <Dropdown
                className={"item" + (props.inputAdditionalClassName == null ? "" : (" " + props.inputAdditionalClassName))}
                value={props.val}
                onChange={handleOnChange}
                options={props.options}
                disabled={props.disable != undefined && props.disable}
            />
        </div>
    </>
}

export default PredefinedNumberSetProperty